export const DEFAULT_IMAGE_WIDTHS = [
    320, 500, 680, 800, 960, 1280, 1920, 2400, 2880
];
export function getSrcSetImageWidths(maxWidth) {
    return DEFAULT_IMAGE_WIDTHS.filter(w => w < maxWidth);
}
